import {
	useRouteMatch, Route, Switch
} from 'react-router';
import { urls } from '../../../Constants';
import KitThresholdListPage from '../../../Pages/Food Products/KitThreshold/KitThresholdListPage';

const getSubURL = (entity) => {
	const baseEntity = urls.KIT_THRESHOLD;
	return entity.slice(baseEntity.length);
};

const KitThresholdRoutes = () => {
	const { path } = useRouteMatch();
	return (
		<Switch>
			<Route exact path={`${path}${getSubURL(urls.KIT_THRESHOLD)}`}>
				<KitThresholdListPage />
			</Route>
		</Switch>
	);
};

export default KitThresholdRoutes;
